import { DISPATCH_STATUS_CODE, TRIPS } from '@/constants';
import constants from '@/helpers/constants';
import { Logger } from '@/services/Logger';
import { TripUpdateReq } from '@/services/signalr/MessageTypes/TripUpdateReq';
import { Signalr } from '@/services/signalr/Signalr';

export type CancelTripParams = {
  tripId: string;
  unitId?: string;
  tripStatus: string;
  reasonId?: string | number;
  cancelReason?: string;
  comments?: string;
  recurringSeriesId?: string;
  pickupDateTime?: string;
  requesterKey?: string;
  requesterName?: string;
  tripSource?: string;
};

export async function cancelTrip(
  signalr: Signalr,
  logger: Logger,
  params: CancelTripParams,
): Promise<void> {
  try {
    await signalr.invoke(TripUpdateReq, {
      tripStatus: `${Number(params.tripStatus) * -1}`,
      contextKey: constants.UI.CONTEXTS.CANCEL_TRIP,
      id: params.tripId,
      requesterKey: params.requesterKey,
      requesterName: params.requesterName,
      ...(params.unitId ? { unitId: params.unitId } : {}),
      status: {
        id: params.tripStatus === TRIPS.STATUS.CANCELED_WILL_CALL
          ? TRIPS.STATUS.CANCELED_WILL_CALL
          : DISPATCH_STATUS_CODE.CANCEL,
      },
      tripReasons: [
        {
          reasonType: constants.TRIPS.ACTIONS.CANCEL,
          reasonValue: { Id: params.reasonId, value: params.cancelReason },
          description: params.comments,
        },
      ],
      ...params.recurringSeriesId && {
        recurringSeriesId: params.recurringSeriesId,
        pickupDateTime: params.pickupDateTime,
      },
      tripSource: params.tripSource,
    });
  }
  catch (error) {
    logger.captureException(error as Error, { tags: { tripManager: 'cancelTrip' } });
  }
}
